module.exports = __webpack_public_path__ + "img/logo.822c5116.svg";